import React from 'react';
import PropTypes from 'prop-types';

import FieldText from '../../fields/fieldText/FieldText';

export default class RestrictedNumberInput extends React.PureComponent {
  static propTypes = {
    float: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    value: PropTypes.number,
    onChange: PropTypes.func
  };

  static defaultProps = {
    min: -Infinity,
    max: Infinity
  };

  static inputProps = {};
  static errorProps = {error: true, touched: true};

  constructor(props) {
    super(props);

    this.state = {internalValue: props.value === undefined ? '' : props.value, error: false};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({internalValue: nextProps.value, error: false});
    }
  }

  onChange = evt => {
    const {float, min, max, onChange} = this.props;
    const value = float ? parseFloat(evt.target.value) : parseInt(evt.target.value);

    const error = isNaN(value) || value < min || value > max;

    if (!error) {
      this.setState({internalValue: value, error});
      onChange(value);
    } else {
      this.setState({internalValue: evt.target.value, error});
    }
  };

  render() {
    const {internalValue, error} = this.state;

    return (
      <FieldText
        {...this.props}
        meta={error && RestrictedNumberInput.errorProps}
        input={RestrictedNumberInput.inputProps}
        value={internalValue}
        onChange={this.onChange}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/controls/restrictedNumberInput/RestrictedNumberInput.js